"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CostFooter;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_cost-footer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function CostFooter(_ref) {
  var secondaryText = _ref.secondaryText,
      tertiaryText = _ref.tertiaryText,
      cost = _ref.cost;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cost-footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cost-footer__extra-text"
  }, secondaryText ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    caption: true,
    prefixDagger: true
  }, secondaryText) : null, tertiaryText ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    caption: true,
    prefixDoubleDagger: true
  }, tertiaryText) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "cost-footer__cost"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true
  }, "Estimated Subtotal"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading3: true
  }, cost)));
}